function reachVkGoal(data) {
  if (data.javascript.vkCounter && data.javascript.vkTarget) {
    if (window._tmr) {
      try {
        window._tmr.push({
          type: 'reachGoal',
          id: data.javascript.vkCounter,
          goal: data.javascript.vkTarget
        });
      } catch (e) {
        console.error('VK Pixel internal error');
      }
    } else {
      console.error('VK Pixel is not connected or connected incorrectly');
    }
  }
}
export { reachVkGoal };